import * as types from '../mutation-types'
import feestrService from '../../services/feestrs'

const state = {
  loading: false,
  errors: null,
  feestrs: [],
}

const actions = {
  getAll({ commit }) {
    commit(types.FEESTR_LOADING, true)
    feestrService.getAll().then(
      response => {

        commit(types.LOAD_FEESTRS, response.data)
        commit(types.FEESTR_LOADING, false)
        commit(types.FEESTR_FAILURE, null)
      },
      error => {
        commit(types.FEESTR_FAILURE, error)
        commit(types.FEESTR_LOADING, false)
      }
    )
  },
  add({ commit }, data) {
    commit(types.FEESTR_LOADING, true)
    commit(types.FEESTR_FAILURE, null)
    data.roles = ['feestr']
    feestrService.add(data).then(
      response => {
        data.id = response.data.id
        //console.log(response.data)
        data.adcharges = response.data.adcharges
        data.adcharges_sum = data.adcharges ? data.adcharges.reduce((sum, ac) => {
          return sum + parseFloat(ac.amount)
        }, 0) : 0
        commit(types.ADD_FEESTR, data)
        commit(types.FEESTR_LOADING, false)

      },
      error => {
        commit(types.FEESTR_FAILURE, error)
        commit(types.FEESTR_LOADING, false)
      }
    )
  },
  update({ commit }, data) {
    commit(types.FEESTR_LOADING, true)
    commit(types.FEESTR_FAILURE, null)
    feestrService.update(data.feestr)
      .then(
        response => {

          data.feestr.adcharges = response.data.adcharges
          data.feestr.adcharges_sum = data.feestr.adcharges ? data.feestr.adcharges.reduce((sum, ac) => {
            return sum + parseFloat(ac.amount)
          }, 0) : 0

          //console.log(data)
          commit(types.UPDATE_FEESTR, data)
          commit(types.FEESTR_LOADING, false)

        },
        error => {
          commit(types.FEESTR_FAILURE, error)
          commit(types.FEESTR_LOADING, false)
        }
      )


  },
  delete({ commit }, data) {
    commit(types.FEESTR_LOADING, true)
    commit(types.FEESTR_FAILURE, null)
    feestrService.delete(data.feestr.id)
      .then(
        response => {

          commit(types.DELETE_FEESTR, data)
          commit(types.FEESTR_LOADING, false)

        },
        error => {
          commit(types.FEESTR_FAILURE, error)
          commit(types.FEESTR_LOADING, false)
        }
      )
  }
}

const mutations = {
  [types.ADD_FEESTR](state, payload) {
    state.feestrs.unshift(payload);

  },
  [types.LOAD_FEESTRS](state, payload) {
    state.feestrs = payload
  },
  [types.UPDATE_FEESTR](state, payload) {
    Object.assign(state.feestrs[payload.index], payload.feestr);
  },
  [types.DELETE_FEESTR](state, payload) {
    state.feestrs.splice(payload.index, 1)
  },
  [types.FEESTR_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.FEESTR_LOADING](state, payload) {
    state.loading = payload
  },
}


const getters = {
  FEESTRS: state => {
    return state.feestrs
  },

  FEESTR_ERROR: state => {
    return state.errors
  },

  FEESTR_LOADING: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/feestrs.js